import { Avatar, Divider, Grid } from '@material-ui/core';
import React from 'react';
import AlertNew from '../../commons/dialogs/AlertNew';
import SpecificComponent from '../../commons/SpecificComponent';
import avatar from '../../Pics/avatar.jpg'
import LocalStorage from '../../providers/LocalStorage';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';


export default class ListaCandidati extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            alertView: false,
            candidatToDelete: {}

        }
    }

    componentDidMount() {
        this.access()
    }

    u = new Utils()
    ls = new LocalStorage().GetUserData()
    ws = new Ws()

    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.EsteSef === 1 ? false : true })
        }


    }

    numeAvatar = (nume) => {

        if (nume) {
            let n = nume.split(' ')

            // console.log('n :>> ', n);

            let firstLetters = ''

            if (n[0]) {

                firstLetters += n[0].substring(0, 1)

            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }

            firstLetters = firstLetters.toUpperCase()

            return firstLetters
        } else {
            return 'NA'
        }


    }


    deleteCandidat = async () => {

        let delCandidat = await this.ws.update('angajati', { inactiv: 2 }, { id: this.state.candidatToDelete.id })

        if (delCandidat.Succes) {

            this.setState({
                alertDelete: false,
                candidatToDelete: {}
            }, () => {
                this.props.getData()

            })

        }

    }

    openDeleteCandiat = (a) => {
        this.setState({
            candidatToDelete: a,
            alertDelete: true
        })
    }

    render() {
        return (
            <div>

                <AlertNew
                    open={this.state.alertDelete}
                    dialogClose={() => { this.setState({ alertDelete: false }) }}
                    title={'Sunteti sigur ca doriti sa stergeti acest candidat?'}
                    // mesaj={this.dictionary.proiecte.alertViewMessage}

                    yesFunction={this.deleteCandidat}

                />

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />
                <Grid container>
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, overflow: 'scroll' }}>

                            {this.props.title &&

                                <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.props.title}</h5>
                                </Grid>

                            }


                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>

                                    <Grid style={{ paddingTop: 5 }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                        <div style={{ position: 'relative' }}>
                                            <select
                                                id='departament'
                                                style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                                className='add-project-input'
                                                type="text"
                                                margin="normal"
                                                name='tva'
                                                // disabled={this.state.departamentDisabled !== 1 ? true : false}
                                                value={this.props.departament || ""}
                                                onChange={(ev) => { this.props.changeDepartament(ev) }}
                                                placeholder={this.dictionary.pontaje.departamentCautaLucrator}
                                            >

                                                <option value={-1}>{this.dictionary.pontaje.toate}</option>
                                                {this.props.departamente.map((s, idx) => {
                                                    return (
                                                        <option key={idx} value={s.id}>{s.nume}</option>
                                                    )
                                                })}
                                            </select>
                                            {/* <label className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.evaluari.selecteaza}</label> */}
                                        </div>

                                    </Grid>
                                    <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>


                                        <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.dataInterviu}</span>

                                    </Grid>

                                    <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                        <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.functie}</span>


                                    </Grid>
                                    <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={3} sm={3} md={3} lg={3} xl={3}>

                                        <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.specializari}</span>


                                    </Grid>


                                    <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={1} sm={1} md={1} lg={1} xl={1}>

                                        <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.operatiuni}</span>


                                    </Grid>




                                </Grid>
                                <Divider style={{ marginTop: 20, marginBottom: 20 }} className="pm-divider" />
                            </Grid>


                            {this.props.angajati.map((a, idx) => {

                                return (

                                    <Grid style={{ marginBottom: 20 }} key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container>

                                            <Grid style={{ paddingTop: 5 }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                <Grid container>

                                                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                        {
                                                            a.poza &&
                                                            <div
                                                                className='pm-angajati-picture'

                                                                style={{ backgroundImage: `url('${a.poza ? (new Ws().adresaMedia + '/Angajati/' + a.poza) : avatar}')`, width: 36, height: 36, padding: 5 }}>

                                                            </div>
                                                        }
                                                        {!a.poza &&

                                                            <Avatar
                                                                className='pm-angajati-picture'
                                                                style={{ display: 'inline-block', textAlign: 'center', height: 24, width: 24, backgroundColor: new Utils().culoriUtilizatori(a.id), padding: 5, cursor: 'pointer' }}>
                                                                {/* <i style={{ verticalAlign: '-webkit-baseline-middle', cursor: 'pointer' }} className='material-icons'>person</i> */}
                                                                <span style={{ display: 'block' }}>{this.numeAvatar(a.nume)} </span>
                                                            </Avatar>
                                                            // <Avatar onClick={this.props.userClick} style={{ display: 'inline-flex' }} className='pm-avatar'> {this.getLitereAvatar(u.nume + ' ')} </Avatar>
                                                        }
                                                    </Grid>

                                                    <Grid style={{ textAlign: 'left' }} item xs={9} sm={9} md={9} lg={9} xl={9}>
                                                        <span style={{ fontWeight: 500, fontSize: 14 }}>    {a.nume}</span><br />
                                                        <span style={{
                                                            fontSize: 12,
                                                            color: '#9a9a9a'
                                                        }}> {this.dictionary.pontaje.candidat} - {a.functie}</span>
                                                    </Grid>

                                                </Grid>

                                            </Grid>
                                            <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>


                                                <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.dataInterviu}</span>
                                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.u.ParseDataFromSql(a.data_interviu) !== 'null' ? this.u.ParseDataFromSql(a.data_interviu) : ' '}</span>

                                            </Grid>

                                            <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.functie}</span>
                                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{a.functie}</span>


                                            </Grid>
                                            <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={3} sm={3} md={3} lg={3} xl={3}>

                                                <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.dictionary.pontaje.specializari}</span>
                                                <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{a.pozitie}</span>


                                            </Grid>


                                            <Grid style={{ textAlign: 'center', paddingTop: 15 }} item xs={1} sm={1} md={1} lg={1} xl={1}>

                                                <i onClick={() => { this.props.history.push(`/fisapersonalaangajat/${a.id}`) }} style={{ marginRight: 20, cursor: 'pointer' }} className='material-icons'>folder</i>
                                                <i onClick={() => { this.openDeleteCandiat(a) }} style={{ marginRight: 20, cursor: 'pointer' }} className='material-icons'>delete</i>

                                                {/* <i className='material-icons'>assessment</i> */}


                                            </Grid>




                                        </Grid>

                                    </Grid>
                                )


                            })}


                        </Grid>


                    </Grid>
                </Grid>
            </div>
        );
    }
}